import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export interface IInitModel {
    /** （图片编辑）是否载已入舞台 */
    finishInit: boolean;
    setFinishInit: (finishInit: boolean) => void;
    /** 是否调用过获取用户信息接口 */
    hasGetInfo: boolean;
    setHasGetInfo: (payload: boolean) => void;
}

const useInitModel = create<IInitModel>()(
    immer((set) => ({
        finishInit: false,
        setFinishInit: (finishInit) =>
            set((state) => {
                state.finishInit = finishInit;
            }),
        hasGetInfo: false,
        setHasGetInfo: (payload) =>
            set((state) => {
                state.hasGetInfo = payload;
            }),
    })),
);

export { useInitModel };
export const getInitModel = () => useInitModel.getState();
